// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"verifyEmail_wrapper__2igDb","dialog":"verifyEmail_dialog__22el9","title":"verifyEmail_title__2SfRs","description":"verifyEmail_description__2A8II"};